import { render, staticRenderFns } from "./TransferPrice.vue?vue&type=template&id=6d839323&scoped=true"
import script from "./TransferPrice.vue?vue&type=script&lang=js"
export * from "./TransferPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d839323",
  null
  
)

export default component.exports